import { isGoogleDocsUrl, isNotionUrl } from "@shared/blocks/link/cloud-document/host-urls";
// Platform detection for URLs
import { detectShippingCarrierFromHostname, isHost } from "@shared/types/shipping";
// Detect the platform from a URL, returns undefined if unknown
export function detectPlatform(url) {
    if (!url)
        return undefined;
    if (isGoogleDocsUrl(url))
        return "google_docs";
    if (isNotionUrl(url))
        return "notion";
    try {
        const parsed = new URL(url);
        const hostname = parsed.hostname.toLowerCase();
        if (isHost(hostname, "gist.github.com"))
            return "gist";
        if (isHost(hostname, "raw.githubusercontent.com") ||
            (isHost(hostname, "github.com") && /\/[^/]+\/[^/]+\/blob\//i.test(parsed.pathname))) {
            return "gist";
        }
        if (isHost(hostname, "twitter.com") || isHost(hostname, "x.com") || isHost(hostname, "t.co")) {
            return "twitter";
        }
        if (isHost(hostname, "github.com"))
            return "github";
        if (isHost(hostname, "youtube.com") || isHost(hostname, "youtu.be"))
            return "youtube";
        if (isHost(hostname, "substack.com"))
            return "substack";
        if (isHost(hostname, "wikipedia.org"))
            return "wikipedia";
        const shippingCarrier = detectShippingCarrierFromHostname(hostname);
        if (shippingCarrier)
            return shippingCarrier;
    }
    catch {
        return undefined;
    }
    return undefined;
}
/**
 * Resolve platform from full link payload, with URL-independent fallbacks for
 * transient states where url may briefly be absent during UI transitions.
 */
export function detectLinkPlatform(content) {
    // Subtype is the cleanest signal — the handler has already classified.
    if (content.subtype === "twitter")
        return "twitter";
    if (content.subtype === "youtube")
        return "youtube";
    if (content.subtype === "wikipedia")
        return "wikipedia";
    if (content.subtype === "dictionary")
        return "dictionary";
    if (content.subtype === "substack")
        return "substack";
    if (content.subtype === "github")
        return "github";
    if (content.subtype === "gist")
        return "gist";
    if (content.subtype === "shipping") {
        return content.shipping.carrier;
    }
    if (content.subtype === "cloud_document") {
        if (content.cloud_document.provider === "google_docs")
            return "google_docs";
        if (content.cloud_document.provider === "notion")
            return "notion";
    }
    const urlPlatform = detectPlatform(content.url);
    if (urlPlatform)
        return urlPlatform;
    // Domain often survives while canonical URL is still settling.
    const domain = content.domain?.toLowerCase();
    if (!domain)
        return undefined;
    if (domain.includes("gist.github.com"))
        return "gist";
    if (domain.includes("raw.githubusercontent.com"))
        return "gist";
    if (domain.includes("github.com"))
        return "github";
    if (domain.includes("youtube.com") || domain.includes("youtu.be"))
        return "youtube";
    if (domain.includes("substack.com"))
        return "substack";
    if (domain.includes("wikipedia.org"))
        return "wikipedia";
    if (domain.includes("twitter.com") || domain.includes("x.com") || domain.includes("t.co"))
        return "twitter";
    return undefined;
}
